"use client";

import { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import AffiliateClickTracker from "./affiliate-click-tracker";

// Client-side only analytics components
const Analytics = dynamic(
  () =>
    import("@vercel/analytics/react").then((mod) => ({
      default: mod.Analytics,
    })),
  { ssr: false }
);

const GoogleAnalytics = dynamic(() => import("./google-analytics"), {
  ssr: false,
});

const PerformanceMonitor = dynamic(
  () => import("@/components/seo/performance-monitor"),
  { ssr: false }
);

const CookieConsent = dynamic(() => import("@/components/cookie-consent"), {
  ssr: false,
});

export default function ClientAnalytics() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null; // Don't render on server
  }

  return (
    <>
      <Analytics />
      <GoogleAnalytics />
      <AffiliateClickTracker />
      <PerformanceMonitor />
      <CookieConsent />
    </>
  );
}
